import { dayLabel, parseDay, today as todayDay, yearMonths } from '../../lib/calendar.js'
import { wallText } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-year ---
let __fez_component_0;
{
const SHOWN = 3
const LANES = 3

/** "Nov 3", "Nov 3 - 5", "Oct 30 - Nov 2" in the viewer's locale. */
function daysText(first, last) {
  const format = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' })
  return first === last ? format.format(parseDay(first)) : format.formatRange(parseDay(first), parseDay(last))
}
__fez_component_0 = class {
  PROPS = {
    day: String,
    items: Array,
    marks: { type: Object, default: null },
    on_day: { type: Function, state: true, default: () => {} },
    on_month: { type: Function, state: true, default: () => {} },
    on_open: { type: Function, state: true, default: () => {} },
  }

  day(day) {
    this.state.on_day(day)
  }

  month(day) {
    this.state.on_month(day)
  }

  open(key) {
    this.state.on_open(key)
  }

  beforeRender() {
    const today = todayDay()
    const months = yearMonths(this.props.day, this.props.items || [])
    this.state.weekdays = months[0].weeks[0].days.map((entry) => ({ key: entry.day, label: dayLabel(entry.day, { weekday: 'narrow' }), name: dayLabel(entry.day, { weekday: 'long' }) }))
    this.state.months = months.map((month) => ({
      key: month.month,
      name: wallText(parseDay(month.month), { month: 'long' }),
      current: month.month.slice(0, 7) === today.slice(0, 7),
      weeks: month.weeks.map((week) => ({
        key: week.key,
        days: week.days.map((entry, index) => {
          const covering = month.items.filter((item) => item.firstDay <= entry.day && item.lastDay >= entry.day)
          const mark = this.props.marks?.[entry.day]
          return {
            ...entry,
            column: index + 1,
            today: entry.day === today,
            busy: covering.length > 0,
            named: Boolean(mark?.label),
            circled: Boolean(mark?.circled),
            title: [dayLabel(entry.day, { weekday: 'long', month: 'long', day: 'numeric' }), mark?.label, ...covering.map((item) => item.title)].filter(Boolean).join('\n'),
          }
        }),
        bars: week.bars
          .filter((bar) => bar.lane < LANES)
          .map((bar) => ({ key: `${bar.item.key}:${week.key}`, column: `${bar.from + 1} / ${bar.to + 2}`, row: bar.lane + 2, color: bar.item.color, cancelled: bar.item.cancelled })),
      })),
      events: month.items.slice(0, SHOWN).map((item) => ({ key: item.key, title: item.title, color: item.color, cancelled: item.cancelled, days: daysText(item.firstDay, item.lastDay) })),
      more: month.items.length > SHOWN ? `${month.items.length - SHOWN} more` : '',
    }))
  }

  CSS = `:fez {
display:block;height:100%;overflow-y:auto;.yr{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:var(--space-6) var(--space-5);max-width:1280px;margin:0 auto;padding:var(--space-5) var(--space-5) var(--space-10)}.yr-month{display:flex;flex-direction:column;gap:var(--space-2);min-width:0}.yr-name{align-self:flex-start;padding:0 var(--space-1);border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-md);font-weight:var(--weight-semibold);cursor:pointer;&:hover{background:var(--color-bg-hover)}&.current{color:var(--color-accent)}}.yr-dows,.yr-week{display:grid;grid-template-columns:repeat(7,minmax(0,1fr))}.yr-dow{color:var(--color-text-subtle);font-size:var(--text-2xs);font-weight:var(--weight-semibold);line-height:20px;text-align:center;text-decoration:none}.yr-week{grid-template-rows:24px repeat(3,3px) 2px;row-gap:1px}.yr-day{grid-row:1 / -1;display:flex;justify-content:center;min-width:0;padding:0;border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);line-height:24px;font-variant-numeric:tabular-nums;cursor:pointer;&:hover{background:var(--color-bg-hover);color:var(--color-text)}&.busy{color:var(--color-text);font-weight:var(--weight-semibold)}}.yr-num{display:inline-grid;place-items:center;min-width:22px;height:22px;margin-top:1px;border-radius:var(--radius-full);line-height:1}.yr-day.named{color:var(--color-accent);font-weight:var(--weight-semibold)}.yr-num.circled{outline:2px solid var(--color-danger);outline-offset:0}.yr-day.today .yr-num{background:var(--color-accent);color:var(--color-accent-text)}.yr-blank{grid-row:1 / -1}.yr-bar{z-index:1;margin:0 1px;border-radius:2px;background:var(--tag);pointer-events:none;&.cancelled{opacity:0.4}}.yr-events{display:grid;gap:2px;margin:0;padding:0;list-style:none}.yr-event{display:flex;align-items:center;gap:var(--space-2);width:100%;min-width:0;padding:1px var(--space-1);border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-xs);text-align:left;cursor:pointer;&:hover{background:var(--color-bg-hover)}&.cancelled .yr-event-title{text-decoration:line-through;opacity:0.7}}.yr-swatch{width:8px;height:8px;flex:none;border-radius:2px;background:var(--tag)}.yr-event-days{flex:none;color:var(--color-text-muted);font-variant-numeric:tabular-nums}.yr-event-title{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.yr-more{justify-self:start;padding:0 var(--space-1);border:0;background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);cursor:pointer;&:hover{color:var(--color-text)}}@media (max-width:1279px){.yr{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (max-width:899px){.yr{grid-template-columns:repeat(2,minmax(0,1fr));gap:var(--space-5) var(--space-4)}} :mobile {.yr{padding:var(--space-3) var(--space-3) var(--space-8)}.yr-event-days{display:none}}
}`

  HTML = `<div class="yr">
{#each state.months as month}
<section class="yr-month" key={month.key}>
<button type="button" class="yr-name" class:current={month.current} onclick="fez.month('{month.key}')">{month.name}</button>
<div>
<div class="yr-dows">
{#each state.weekdays as weekday}
<abbr class="yr-dow" key={weekday.key} title={weekday.name}>{weekday.label}</abbr>
{/each}
</div>
{#each month.weeks as week}
<div class="yr-week" key={week.key}>
{#each week.days as entry}
{#if entry.inside}
<button type="button" class="yr-day" class:today={entry.today} class:busy={entry.busy} class:named={entry.named} key={entry.day} style="grid-column: {entry.column}" title={entry.title} onclick="fez.day('{entry.day}')"><span class="yr-num" class:circled={entry.circled}>{entry.num}</span></button>
{:else}
<span class="yr-blank" key={entry.day} style="grid-column: {entry.column}"></span>
{/if}
{/each}
{#each week.bars as bar}
<span class="yr-bar" class:cancelled={bar.cancelled} key={bar.key} style="grid-column: {bar.column}; grid-row: {bar.row}; --tag: var(--color-avatar-{bar.color})"></span>
{/each}
</div>
{/each}
</div>
{#if month.events.length}
<ul class="yr-events">
{#each month.events as event}
<li key={event.key}>
<button type="button" class="yr-event" class:cancelled={event.cancelled} style="--tag: var(--color-avatar-{event.color})" title="{event.days}: {event.title}" onclick="fez.open('{event.key}')">
<span class="yr-swatch"></span>
<span class="yr-event-days">{event.days}</span>
<span class="yr-event-title">{event.title}</span>
</button>
</li>
{/each}
{#if month.more}
<li><button type="button" class="yr-more" onclick="fez.month('{month.key}')">{month.more}</button></li>
{/if}
</ul>
{/if}
</section>
{/each}
</div>`
};
}

Fez('calendar-year', __fez_component_0);

export default __fez_component_0;
